"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  registerReducer: true,
  registerMiddleware: true,
  CourierContext: true,
  CourierProvider: true
};
exports.CourierProvider = exports.CourierContext = exports.registerMiddleware = exports.registerReducer = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = _interopRequireWildcard(require("react"));

var _createReducer = _interopRequireDefault(require("react-use/lib/factory/createReducer"));

var _reducer = _interopRequireWildcard(require("./reducer"));

var _middleware2 = _interopRequireWildcard(require("./middleware"));

var _useCourierActions = _interopRequireDefault(require("./hooks/use-courier-actions"));

var _usePageVisible = require("./hooks/use-page-visible");

var _useTransport = _interopRequireDefault(require("./hooks/use-transport"));

var _useClientSourceId = _interopRequireDefault(require("./hooks/use-client-source-id"));

var _transports = require("./transports");

Object.keys(_transports).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _transports[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _transports[key];
    }
  });
});

var _hooks = require("./hooks");

Object.keys(_hooks).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _hooks[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _hooks[key];
    }
  });
});

var _lib = require("./lib");

Object.keys(_lib).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _lib[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _lib[key];
    }
  });
});

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

if (typeof window !== "undefined") {
  window.global = window; // @ts-ignore
  // eslint-disable-next-line @typescript-eslint/no-var-requires

  window.Buffer = window.Buffer || require("buffer").Buffer;
}

var registerReducer = _reducer.registerReducer;
exports.registerReducer = registerReducer;
var registerMiddleware = _middleware2.registerMiddleware;
exports.registerMiddleware = registerMiddleware;

var CourierContext = /*#__PURE__*/_react["default"].createContext(undefined);

exports.CourierContext = CourierContext;

var CourierProvider = function CourierProvider(_ref) {
  var _window;

  var apiUrl = _ref.apiUrl,
      authorization = _ref.authorization,
      brand = _ref.brand,
      brandId = _ref.brandId,
      children = _ref.children,
      clientKey = _ref.clientKey,
      id = _ref.id,
      inboxApiUrl = _ref.inboxApiUrl,
      _ref$localStorage = _ref.localStorage,
      localStorage = _ref$localStorage === void 0 ? typeof window !== "undefined" ? (_window = window) === null || _window === void 0 ? void 0 : _window.localStorage : undefined : _ref$localStorage,
      _ref$middleware = _ref.middleware,
      _middleware = _ref$middleware === void 0 ? [] : _ref$middleware,
      onMessage = _ref.onMessage,
      onRouteChange = _ref.onRouteChange,
      _transport = _ref.transport,
      userId = _ref.userId,
      userSignature = _ref.userSignature,
      _ref$wsOptions = _ref.wsOptions,
      _wsOptions = _ref$wsOptions === void 0 ? {} : _ref$wsOptions;

  var wsOptions = (0, _react.useMemo)(function () {
    return _wsOptions;
  }, [_wsOptions.connectionTimeout, _wsOptions.onClose, _wsOptions.onError, _wsOptions.onReconnect, _wsOptions.url]);
  var clientSourceId = (0, _useClientSourceId["default"])({
    authorization: authorization,
    clientKey: clientKey,
    id: id,
    localStorage: localStorage,
    userId: userId
  });
  var middleware = [].concat((0, _toConsumableArray2["default"])(_middleware), (0, _toConsumableArray2["default"])(_middleware2["default"]));
  var useReducer = (0, _react.useCallback)(_createReducer["default"].apply(void 0, (0, _toConsumableArray2["default"])(middleware)), [_middleware]);
  var transport = typeof window === "undefined" ? undefined : (0, _useTransport["default"])({
    authorization: authorization,
    clientSourceId: clientSourceId,
    clientKey: clientKey,
    transport: _transport,
    userSignature: userSignature,
    wsOptions: wsOptions
  });

  var _useReducer = useReducer(_reducer["default"], {
    apiUrl: apiUrl,
    authorization: authorization,
    brand: brand,
    brandId: brandId,
    clientKey: clientKey,
    clientSourceId: clientSourceId,
    inboxApiUrl: inboxApiUrl,
    localStorage: localStorage,
    middleware: middleware,
    onRouteChange: onRouteChange,
    transport: transport,
    userId: userId,
    userSignature: userSignature
  }),
      _useReducer2 = (0, _slicedToArray2["default"])(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var actions = (0, _useCourierActions["default"])(state, dispatch);
  (0, _usePageVisible.usePageVisible)(function (isVisible) {
    if (!isVisible) {
      return;
    } // this means we left the tab and came back so we should refetch


    actions.pageVisible();
  });
  (0, _react.useEffect)(function () {
    if (_transport) {
      // this means the transport was passed in and we shouldn't subscribe
      return;
    }

    if (!transport || !userId) {
      return;
    }

    var courierTransport = transport;
    courierTransport.subscribe(userId);
    courierTransport.onReconnection({
      id: "handleWSReconnection",
      callback: function callback() {
        actions.wsReconnected();
      }
    });

    if (onMessage) {
      courierTransport.intercept(onMessage);
    }

    var intervalId = setInterval(function () {
      courierTransport.keepAlive();
    }, 300000); // 5 minutes

    return function () {
      clearInterval(intervalId);
      courierTransport.unsubscribe(userId);
      courierTransport.closeConnection();
    };
  }, [actions, transport, userId]);
  (0, _react.useEffect)(function () {
    if (!_transport && (!clientKey || !userId)) {
      return;
    }

    var parsedLocalStorageState;

    if (state.localStorage) {
      var localStorageState = state.localStorage.getItem("".concat(clientKey, "/").concat(userId, "/provider"));

      if (localStorageState) {
        try {
          parsedLocalStorageState = JSON.parse(localStorageState);
        } catch (ex) {
          console.log("error", ex);
        }
      }
    }

    actions.init(_objectSpread({
      apiUrl: apiUrl,
      authorization: authorization,
      brandId: brandId,
      clientKey: clientKey,
      inboxApiUrl: inboxApiUrl,
      localStorage: localStorage,
      transport: transport,
      userId: userId,
      userSignature: userSignature
    }, parsedLocalStorageState));
  }, [actions, apiUrl, authorization, brandId, clientKey, inboxApiUrl, localStorage, transport, userId, userSignature]);
  (0, _react.useEffect)(function () {
    if (!state.brand || !clientKey || !userId || !state.localStorage) {
      return;
    }

    state.localStorage.setItem("".concat(clientKey, "/").concat(userId, "/provider"), JSON.stringify({
      brand: state.brand
    }));
  }, [state.brand, clientKey, userId, state.localStorage]);
  return /*#__PURE__*/_react["default"].createElement(CourierContext.Provider, {
    value: _objectSpread(_objectSpread(_objectSpread({}, state), actions), {}, {
      clientSourceId: clientSourceId,
      dispatch: dispatch
    })
  }, children);
};

exports.CourierProvider = CourierProvider;